import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Dropdown } from 'primeng/dropdown';
import { hasControlErrors, translateOptions } from '../../shared/services/select.utils';
import { sortSelectOptionsAscending } from './util/select-v2.util';
import { DomHandler } from 'primeng/dom';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "@ngx-translate/core";
import * as i3 from "primeng/dropdown";
import * as i4 from "primeng/api";
import * as i5 from "@angular/common";
import * as i6 from "../icon-v2/icon.component";
import * as i7 from "ngx-skeleton-loader";
import * as i8 from "../field-error/field-error.component";
import * as i9 from "primeng/tooltip";
const _c0 = a0 => ({
  "dropdown-upwards": a0
});
const _c1 = a0 => ({
  "gea-select-label-disabled": a0
});
const _c2 = () => ({
  height: "40px",
  width: "100%"
});
function SelectV2Component_div_0_ng_template_3_geaui_icon_v2_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("color", ctx_r1.setDropdownIconColor())("file", ctx_r1.openIcon);
  }
}
function SelectV2Component_div_0_ng_template_3_geaui_icon_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("color", ctx_r1.setDropdownIconColor())("file", ctx_r1.closeIcon);
  }
}
function SelectV2Component_div_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SelectV2Component_div_0_ng_template_3_geaui_icon_v2_0_Template, 1, 2, "geaui-icon-v2", 9)(1, SelectV2Component_div_0_ng_template_3_geaui_icon_v2_1_Template, 1, 2, "geaui-icon-v2", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isDropdownOpen);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isDropdownOpen);
  }
}
function SelectV2Component_div_0_ng_template_4_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("pTooltip", option_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.name);
  }
}
function SelectV2Component_div_0_ng_template_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind1(1, 2, option_r3.toolTipText));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r3.name);
  }
}
function SelectV2Component_div_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SelectV2Component_div_0_ng_template_4_span_0_Template, 2, 2, "span", 11)(1, SelectV2Component_div_0_ng_template_4_span_1_Template, 3, 4, "span", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r1.enableTooltipOptionDescription);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.enableTooltipOptionDescription);
  }
}
function SelectV2Component_div_0_label_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " *");
    i0.ɵɵelementEnd();
  }
}
function SelectV2Component_div_0_label_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, SelectV2Component_div_0_label_5_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r1.isDisabled))("for", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r1.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.required);
  }
}
function SelectV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3)(2, "p-dropdown", 4);
    i0.ɵɵlistener("onLazyLoad", function SelectV2Component_div_0_Template_p_dropdown_onLazyLoad_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLazyLoad.emit($event));
    })("onShow", function SelectV2Component_div_0_Template_p_dropdown_onShow_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.isDropdownOpen = true;
      return i0.ɵɵresetView(ctx_r1.checkDropdownUpwardsOpen());
    })("onHide", function SelectV2Component_div_0_Template_p_dropdown_onHide_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isDropdownOpen = false);
    })("onChange", function SelectV2Component_div_0_Template_p_dropdown_onChange_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectChanged.emit($event.value));
    });
    i0.ɵɵtemplate(3, SelectV2Component_div_0_ng_template_3_Template, 2, 2, "ng-template", 5)(4, SelectV2Component_div_0_ng_template_4_Template, 2, 2, "ng-template", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SelectV2Component_div_0_label_5_Template, 4, 8, "label", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "geaui-field-error", 8);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("p-float-label", ctx_r1.floatLabelType === "auto");
    i0.ɵɵproperty("ngClass", ctx_r1.alwaysFloatLabel ? "gea-always-float-label" : "");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("isDropdownOpen", ctx_r1.isDropdownOpen);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c0, ctx_r1.isOpenedUpwards))("id", ctx_r1.id)("appendTo", "body")("formControlName", (tmp_9_0 = ctx_r1.formName) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ctx_r1.id)("autoDisplayFirst", ctx_r1.autoDisplayFirst)("options", ctx_r1.options)("disabled", ctx_r1.isDisabled)("placeholder", ctx_r1.label)("inputId", ctx_r1.labelId)("optionValue", ctx_r1.formName ? "value" : undefined)("virtualScroll", ctx_r1.virtualScroll)("virtualScrollItemSize", ctx_r1.virtualScrollItemSize)("virtualScrollOptions", ctx_r1.virtualScrollOptions)("lazy", ctx_r1.lazy)("overlayOptions", ctx_r1.getOverlayOptions());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.floatLabelType === "auto");
    i0.ɵɵadvance();
    i0.ɵɵproperty("fieldName", i0.ɵɵpipeBind1(7, 25, ctx_r1.label))("submitted", ctx_r1.submitted)("errors", ctx_r1.control == null ? null : ctx_r1.control.errors);
  }
}
function SelectV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2));
  }
}
export class SelectV2Component {
  formBuilder;
  translateService;
  el;
  destroyed;
  id = 'select';
  formName = undefined;
  group;
  label = '';
  required = false;
  /*
   * @deprecated This property has been marked as deprecated by primeNG and is therefor also deprecated on our end.
   */
  autoDisplayFirst = false;
  loading = false;
  options = [];
  disabled = false;
  selected = null;
  floatLabelType = 'auto';
  alwaysFloatLabel = false;
  validationsError = 'UI-LIB.GENERAL.SELECT-ERROR';
  submitted = false;
  enableTooltipOptionDescription = false;
  virtualScroll = false;
  virtualScrollItemSize;
  virtualScrollOptions;
  sortOptions = true;
  sortFunction = sortSelectOptionsAscending;
  lazy = false;
  // keeping the property name as onLazyLoad to match the primeNG event name
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onLazyLoad = new EventEmitter();
  selectChanged = new EventEmitter();
  selectDropdown;
  openIcon = '16px_chevron-up';
  closeIcon = '16px_chevron-down';
  isDropdownOpen = false;
  isOpenedUpwards = false;
  constructor(formBuilder, translateService, el, destroyed) {
    this.formBuilder = formBuilder;
    this.translateService = translateService;
    this.el = el;
    this.destroyed = destroyed;
    this.group = this.group || this.formBuilder.group({
      [this.formName ?? this.id]: new FormControl(this.selected)
    });
  }
  get isDisabled() {
    return this.control?.disabled;
  }
  ngOnInit() {
    if (this.selected) this.setSelectedOption(this.selected);
    if (this.required) this.control?.setValidators([Validators.required]);
    this.translateService.onLangChange.pipe(takeUntilDestroyed(this.destroyed)).subscribe(() => {
      translateOptions(this.options, this.translateService);
      if (this.sortOptions) this.options = this.sortFunction(this.options);
      const currentValue = this.control?.value;
      this.control?.setValue(undefined);
      this.control?.setValue(currentValue);
    });
  }
  ngAfterViewInit() {
    this.selectDropdown?.onHide.pipe(takeUntilDestroyed(this.destroyed)).subscribe(() => {
      this.selectDropdown.focused = false;
    });
    window.addEventListener('resize', this.alignOverlayPanel.bind(this));
    document.addEventListener('scroll', this.alignOverlayPanel.bind(this), true);
  }
  ngOnDestroy() {
    window.removeEventListener('resize', this.alignOverlayPanel.bind(this));
    document.removeEventListener('scroll', this.alignOverlayPanel.bind(this));
  }
  ngOnChanges(changes) {
    if (changes?.['selected'] && !changes?.['selected'].firstChange) {
      const currentSelectOption = changes?.['selected'].currentValue;
      this.setSelectedOption(currentSelectOption);
    }
    if (changes?.['options'] && this.options) {
      translateOptions(this.options, this.translateService);
      if (this.sortOptions) this.options = this.sortFunction(this.options);
    }
    if (changes['disabled']) {
      const isDisabled = changes['disabled'].currentValue;
      isDisabled ? this.control?.disable() : this.control?.enable();
    }
    if (changes['required']) {
      const isRequired = changes['required'].currentValue;
      isRequired ? this.control?.setValidators([Validators.required]) : this.control?.clearValidators();
      this.control?.updateValueAndValidity();
    }
  }
  get control() {
    return this.group.get(this.formName ?? this.id);
  }
  //Known issue of p-dropdown and label for attribute: https://github.com/primefaces/primeng/issues/15268
  //should normally fix console error with Incorrect use of <label for=FORM_ELEMENT>
  get labelId() {
    return this.id + '-labelId';
  }
  getOverlayOptions() {
    return {
      listener: (event, options) => {
        if (options?.type === 'scroll' || options?.type === 'resize') {
          return false;
        }
        return options?.valid;
      }
    };
  }
  hasErrors() {
    return hasControlErrors(this.control);
  }
  setDropdownIconColor() {
    if (this.isDisabled) return 'grey';
    if (this.selectDropdown?.focused || this.hasErrors()) return 'focus';
    return 'blue';
  }
  checkDropdownUpwardsOpen() {
    const dropdownPanels = document.body.querySelectorAll('.p-overlay');
    dropdownPanels.forEach(panel => {
      this.isOpenedUpwards = panel.style.transformOrigin === 'center bottom';
    });
  }
  setSelectedOption(selectOption) {
    const option = this.findSelectedOption(selectOption);
    if (option) setTimeout(() => this.control?.patchValue(option));
    // eslint-disable-next-line no-console
    else console.error(`No control found`);
  }
  findSelectedOption(selectedOption) {
    if (selectedOption === null) return;
    return this.options.find(opt => selectedOption.name === opt.name || selectedOption.value === opt.value);
  }
  alignOverlayPanel() {
    if (!this.isDropdownOpen) {
      return;
    }
    const elements = document.body.getElementsByClassName('p-overlay');
    if (elements.length > 0) {
      const overlay = elements[0];
      DomHandler.alignOverlay(overlay, this.selectDropdown?.containerViewChild?.nativeElement, document.body);
    }
    this.checkDropdownUpwardsOpen();
  }
  static ɵfac = function SelectV2Component_Factory(t) {
    return new (t || SelectV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SelectV2Component,
    selectors: [["geaui-select-v2"]],
    viewQuery: function SelectV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(Dropdown, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectDropdown = _t.first);
      }
    },
    inputs: {
      id: "id",
      formName: "formName",
      group: "group",
      label: "label",
      required: "required",
      autoDisplayFirst: "autoDisplayFirst",
      loading: "loading",
      options: "options",
      disabled: "disabled",
      selected: "selected",
      floatLabelType: "floatLabelType",
      alwaysFloatLabel: "alwaysFloatLabel",
      validationsError: "validationsError",
      submitted: "submitted",
      enableTooltipOptionDescription: "enableTooltipOptionDescription",
      virtualScroll: "virtualScroll",
      virtualScrollItemSize: "virtualScrollItemSize",
      virtualScrollOptions: "virtualScrollOptions",
      sortOptions: "sortOptions",
      sortFunction: "sortFunction",
      lazy: "lazy"
    },
    outputs: {
      onLazyLoad: "onLazyLoad",
      selectChanged: "selectChanged"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [["skeleton", ""], ["class", "gea-form-container-margin", 3, "formGroup", 4, "ngIf", "ngIfElse"], [1, "gea-form-container-margin", 3, "formGroup"], [1, "gea-select-field", 3, "ngClass"], ["optionLabel", "name", "data-cy", "dropdown", 1, "w-full", 3, "onLazyLoad", "onShow", "onHide", "onChange", "ngClass", "id", "appendTo", "formControlName", "autoDisplayFirst", "options", "disabled", "placeholder", "inputId", "optionValue", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "lazy", "overlayOptions"], ["pTemplate", "dropdownicon"], ["pTemplate", "item"], ["data-cy", "label", 3, "ngClass", "for", 4, "ngIf"], [3, "fieldName", "submitted", "errors"], [3, "color", "file", 4, "ngIf"], [3, "color", "file"], ["data-cy", "option", 3, "pTooltip", 4, "ngIf"], ["class", "pointer-events-auto", "data-cy", "option", 3, "pTooltip", 4, "ngIf"], ["data-cy", "option", 3, "pTooltip"], ["data-cy", "option", 1, "pointer-events-auto", 3, "pTooltip"], ["data-cy", "label", 3, "ngClass", "for"], [4, "ngIf"], [1, "gea-form-container-margin"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function SelectV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, SelectV2Component_div_0_Template, 8, 29, "div", 1)(1, SelectV2Component_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r4 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r4);
      }
    },
    dependencies: [i3.Dropdown, i4.PrimeTemplate, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName, i5.NgClass, i5.NgIf, i6.IconComponent, i7.NgxSkeletonLoaderComponent, i8.FieldErrorComponent, i9.Tooltip, i2.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-select-v2',
      template: "<div class=\"gea-form-container-margin\" *ngIf=\"!loading; else skeleton\" [formGroup]=\"group\">\n  <span\n    class=\"gea-select-field\"\n    [class.p-float-label]=\"floatLabelType === 'auto'\"\n    [ngClass]=\"alwaysFloatLabel ? 'gea-always-float-label' : ''\">\n    <p-dropdown\n      class=\"w-full\"\n      [ngClass]=\"{ 'dropdown-upwards': isOpenedUpwards }\"\n      [class.isDropdownOpen]=\"isDropdownOpen\"\n      [id]=\"id\"\n      [appendTo]=\"'body'\"\n      [formControlName]=\"formName ?? id\"\n      [autoDisplayFirst]=\"autoDisplayFirst\"\n      [options]=\"options\"\n      [disabled]=\"isDisabled\"\n      [placeholder]=\"label\"\n      [inputId]=\"labelId\"\n      [optionValue]=\"formName ? 'value' : undefined\"\n      [virtualScroll]=\"virtualScroll\"\n      [virtualScrollItemSize]=\"virtualScrollItemSize\"\n      [virtualScrollOptions]=\"virtualScrollOptions\"\n      [lazy]=\"lazy\"\n      [overlayOptions]=\"getOverlayOptions()\"\n      (onLazyLoad)=\"onLazyLoad.emit($event)\"\n      (onShow)=\"isDropdownOpen = true; checkDropdownUpwardsOpen()\"\n      (onHide)=\"isDropdownOpen = false\"\n      (onChange)=\"selectChanged.emit($event.value)\"\n      optionLabel=\"name\"\n      data-cy=\"dropdown\">\n      <ng-template pTemplate=\"dropdownicon\">\n        <geaui-icon-v2 *ngIf=\"isDropdownOpen\" [color]=\"setDropdownIconColor()\" [file]=\"openIcon\"></geaui-icon-v2>\n        <geaui-icon-v2 *ngIf=\"!isDropdownOpen\" [color]=\"setDropdownIconColor()\" [file]=\"closeIcon\"></geaui-icon-v2>\n      </ng-template>\n      <ng-template let-option pTemplate=\"item\">\n        <span *ngIf=\"enableTooltipOptionDescription\" pTooltip=\"{{ option.name }}\" data-cy=\"option\">{{ option.name }}</span>\n        <span\n          class=\"pointer-events-auto\"\n          *ngIf=\"!enableTooltipOptionDescription\"\n          data-cy=\"option\"\n          pTooltip=\"{{ option.toolTipText | translate }}\"\n          >{{ option.name }}</span\n        >\n      </ng-template>\n    </p-dropdown>\n    <label\n      *ngIf=\"floatLabelType === 'auto'\"\n      [ngClass]=\"{ 'gea-select-label-disabled': isDisabled }\"\n      [for]=\"labelId\"\n      data-cy=\"label\">\n      {{ label | translate }}\n      <span *ngIf=\"required\"> *</span>\n    </label>\n  </span>\n  <geaui-field-error [fieldName]=\"label | translate\" [submitted]=\"submitted\" [errors]=\"control?.errors\"></geaui-field-error>\n</div>\n<ng-template #skeleton>\n  <div class=\"gea-form-container-margin\">\n    <ngx-skeleton-loader [theme]=\"{ height: '40px', width: '100%' }\" count=\"1\" appearance=\"line\"></ngx-skeleton-loader>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2.TranslateService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.DestroyRef
  }], {
    id: [{
      type: Input
    }],
    formName: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    autoDisplayFirst: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    floatLabelType: [{
      type: Input
    }],
    alwaysFloatLabel: [{
      type: Input
    }],
    validationsError: [{
      type: Input
    }],
    submitted: [{
      type: Input
    }],
    enableTooltipOptionDescription: [{
      type: Input
    }],
    virtualScroll: [{
      type: Input
    }],
    virtualScrollItemSize: [{
      type: Input
    }],
    virtualScrollOptions: [{
      type: Input
    }],
    sortOptions: [{
      type: Input
    }],
    sortFunction: [{
      type: Input
    }],
    lazy: [{
      type: Input
    }],
    onLazyLoad: [{
      type: Output
    }],
    selectChanged: [{
      type: Output
    }],
    selectDropdown: [{
      type: ViewChild,
      args: [Dropdown]
    }]
  });
})();
